import React, { FC, useEffect, useState } from 'react'
import { Modal, Button, Form } from 'react-bootstrap'
import { FormattedMessage } from 'react-intl'
import { Redirect } from 'react-router-dom'
import { useAppSelector } from '../../hooks/useAppSelector'
import { RoutesPaths } from '../../router'
import { ModalTypes } from '../../types/modals'
import { selectModalData, selectModalType } from '../../store/selectors/modalSelectors'
import { useAppDispatch } from '../../hooks/useAppDispatch'
import { hideModal } from '../../store/actions/modalActions'

const ProductDisableModal: FC = () => {
  const dispatch = useAppDispatch()
  const [show, setShow] = useState<boolean>(true)
  const modalType= useAppSelector(selectModalType)
  const data = useAppSelector(selectModalData)

  const handleClose = (): void => {
    setShow(false)
  }

  useEffect(() => {
    if (!show) dispatch(hideModal())
  }, [show, dispatch])

  if (modalType !== ModalTypes.PRODUCT_UNAVAILABLE_MODAL) return null

  if (!show) return <Redirect to={{ pathname: RoutesPaths.SUMMARY }} />

  return (
    <Modal show={show} backdrop="static" centered onHide={handleClose}>
      <Modal.Header>
        <Modal.Title>
          <FormattedMessage id={data.title} tagName="span" />
        </Modal.Title>
      </Modal.Header>
      {data.message && (
        <Modal.Body>
          <FormattedMessage
            id={data.message}
            tagName="p"
            values={data.values}
          />
        </Modal.Body>
      )}
      <Form>
        <Modal.Footer>
          <Button variant="primary" type="button" onClick={handleClose}>
            Go to home page
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  )
}

export default ProductDisableModal
